import { IconButton } from '@treezor/design-system';

export interface ICellLinkProps {
  label: string;
  handleNavigate: () => void;
  testId?: string;
}

export function CellLink({ label, handleNavigate, testId }: ICellLinkProps) {
  return (
    <div className="flex items-center text-nowrap" data-testid={testId ? `${testId}-link` : 'link'}>
      <span
        className="typo-body-regular-caption text-tertiary mr-2"
        data-testid={`${testId ? `${testId}` : 'link'}-label`}
      >
        ID {label}
      </span>{' '}
      <IconButton
        icon="chevron_right"
        variant="secondary"
        onClick={handleNavigate}
        testId={`${testId ? `${testId}` : 'link'}-icon`}
      />
    </div>
  );
}
